import React from 'react';

import styles from './tablet-max-typography.module.scss';
import { TypographyBase } from '../typography-base';
import { InnerTypographyProps } from '../types';

const TabletMaxTypography: React.FC<InnerTypographyProps> = (props) => {
  return <TypographyBase styles={styles} {...props} />;
};

export { TabletMaxTypography };
